import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import type { INotification } from "@/types/notifications";
import type { INotificationsSlice, INotificationsState } from "./types";

export const initialState: INotificationsState = {
  notifications: [],
  notificationsLoaded: false,
  open: false,
  count: 0,
};

export const useNotificationsStore = create<INotificationsSlice>()(
  immer((set) => ({
    ...initialState,
    setNotifications: (p: INotification[]) => {
      set((state) => {
        state.notifications = p;
        state.notificationsLoaded = true;
      });
    },
    setNotificationsLoaded: (p: boolean) => {
      set((state) => {
        state.notificationsLoaded = p;
      });
    },
    setOpen: (p: boolean) => {
      set((state) => {
        state.open = p;
      });
    },
    append: (p: INotification[]) => {
      set((state) => {
        state.notifications = [...state.notifications, ...p];
        state.notificationsLoaded = true;
      });
    },
    setCount: (p: number) => {
      set((state) => {
        state.count = p;
      });
    },
    readNotification: (p: INotification) => {
      set((state) => {
        if (!p.isRead) {
          state.count--;
        }
        const index = state.notifications.findIndex((n) => n.id === p.id);

        if (index >= 0) {
          state.notifications[index].isRead = true;
        }
      });
    },
    archiveNotification: (p: INotification) => {
      set((state) => {
        if (!p.isRead) {
          state.count--;
        }
        state.notifications = state.notifications.filter((n) => p.id !== n.id);
      });
    },
    readAll: () => {
      set((state) => {
        state.count = 0;
        state.notifications = state.notifications.map((n) => {
          return {
            ...n,
            isRead: true,
          };
        });
      });
    },
    archiveAll: () => {
      set((state) => {
        state.count = 0;
        state.notifications = [];
      });
    },
    reset: () => {
      set(initialState);
    },
  })),
);
